import React from 'react';
import NavigateToWebApps from '../../utils/NavigateToWebApps';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import envConfig from '../../../static/config';
import SessionStore from '../../stores/SessionStore';
import SessionActionCreator from '../../actions/SessionActionCreator';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { StatusBanner } from 'web-ui-components/lib/layout/content';

const PasswordResetAlert = () => {
  const showPwResetReminder = SessionStore.getPwReminderFlag();
  if (!showPwResetReminder) {
    return null;
  }
  return (
    <StatusBanner.Information
      onClose={() => {
        SessionActionCreator.setPwReminderFlag(false);
      }}
      isOpen={showPwResetReminder}
    >
      <StandardBody isFlush>
        <span>
          {'Forgotten your password? Please '}
          <NavigationButton.Tertiary
            labelText="reset your password now"
            onClick={() => {
              NavigateToWebApps.navigateTo(envConfig.manageCredentialLink);
            }}
            isInline
            data-test-id="reset-password"
          />
        </span>
      </StandardBody>
    </StatusBanner.Information>
  );
};

export default PasswordResetAlert;
